import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@shared/constants/routes.enum';
import { PermissionModule } from '@shared/models/permission-matrix.model';
import { AuthStore } from '@features/shared/auth/presentation/store/auth.store';

export function hasModuleAccessGuard(module: PermissionModule, minLevel: 'read' | 'full'): CanActivateFn {
  return async () => {
    // Both injects must happen BEFORE the `await` below -- `inject()` requires an active injection
    // context, which only survives the synchronous portion of this function; injecting `Router`
    // after awaiting `refreshProfile()` would throw NG0203.
    const authStore = inject(AuthStore);
    const router = inject(Router);

    await authStore.refreshProfile();
    if (authStore.hasModuleAccess(module, minLevel)) return true;

    // `reason` tells the landing page which of its two stories to tell: this rejection is a plan
    // (or role) limit on a perfectly valid session, not the wrong kind of account, so the page must
    // not offer its log-out button here -- see WebAccessDeniedPage.
    return router.createUrlTree([AppRoutes.AccessDenied], { queryParams: { reason: 'plan-module' } });
  };
}
